'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosKeypad = function IoIosKeypad(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.9 26.6c2.3 0 4.1 1.9 4.1 4.3s-1.8 4.1-4.1 4.1-4.3-1.8-4.3-4.1 1.9-4.3 4.3-4.3z m-10.9 0c2.3 0 4.1 1.9 4.1 4.3s-1.8 4.1-4.1 4.1-4.1-1.8-4.1-4.1 1.8-4.3 4.1-4.3z m-10.9 0c2.4 0 4.3 1.9 4.3 4.3s-1.9 4.1-4.3 4.1-4.1-1.8-4.1-4.1 1.8-4.3 4.1-4.3z m21.8-10.7c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.1-4.1 4.1-4.3-1.8-4.3-4.1 1.9-4.1 4.3-4.1z m-10.9 0c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.1-4.1 4.1-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1z m-10.9 0c2.4 0 4.3 1.8 4.3 4.1s-1.9 4.1-4.3 4.1-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1z m21.8-2.5c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.1 4.3-4.1 4.1 1.8 4.1 4.1-1.8 4.3-4.1 4.3z m-10.9-8.4c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.3-4.1 4.3-4.1-1.9-4.1-4.3 1.8-4.1 4.1-4.1z m-10.9 0c2.4 0 4.3 1.8 4.3 4.1s-1.9 4.3-4.3 4.3-4.1-1.9-4.1-4.3 1.8-4.1 4.1-4.1z' })
        )
    );
};

exports.default = IoIosKeypad;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-keypad.js
// module id = 2192
// module chunks = 0